import React from 'react';
import { Container } from 'react-bootstrap';

const GoogleMapEmbed = ({ mapEmbed }) => {
  return (
    <section className="map">
      <Container>
        <div style={{ width: '100%', height: '450px' }}>
          <div
            dangerouslySetInnerHTML={{
              __html: mapEmbed || '<div>No map available</div>',
            }}
          />
        </div>
      </Container>
    </section>
  );
};

export default GoogleMapEmbed;